export default __webpack_public_path__ + "static/media/sizzling_sands.c1a1996d.svg";